import React,{ Component } from "react";
import './index.less'
//import yxh from '../../image/banner.jpg'
import Axios from "../../../../components/request/axios";
import {message,Empty,Skeleton} from "antd";
import getIdFromUrl from "../../../../components/getIdFromUrl";
class Video extends Component {
    state={
        width:'3000px',
        MovingDistance:0,
        leftClassName:'iconfont iconarrow-right disabled',
        rightClassName:'iconfont iconarrow-right ',
        scrollXClassName:'after',
        news:[], ///文章内容数组
        channel__id:'',
        isSkeleton:true
    };
    componentDidMount() {
        let _this=this;
        let channel__name='继续教育';
        let params={
            channel__name:channel__name
        };
        Axios.get('/api/v1/train/',params).then((res)=>{
            if(res){
                //console.log(res);
                let news=res.results;
                _this.setState({
                    news:news,
                    channel__id:res.results[0]?res.results[0].channel.split('/')[res.results[0].channel.split('/').length-2]:'',
                    isSkeleton:false
                });
                setTimeout(function () {
                    if(!_this.props.Mobile){//判断不是手机端查看，计算宽度，进行左右滚动
                        let  menusClass=document.getElementsByClassName("item");//menus对象集合
                        let  parent=document.getElementById("scrollX");//
                        if(parent){
                            let  parentWidth=document.getElementById("scrollX").offsetWidth;//
                            let  menusWidths=0;
                            for(let i = 0;i < menusClass.length;i++){//计算menus的宽度
                                let width = menusClass[i].offsetWidth + 20;
                                menusWidths += width;
                            }
                            _this.setState({
                                width:menusWidths,
                                parentWidth:parentWidth
                            });
                            if(parentWidth >= menusWidths){//父级大于子集的集合,设置子集中间显示
                                _this.setState({
                                    leftClassName:'',
                                    rightClassName:'',
                                    scrollXClassName:'margin_auto'
                                })
                            }
                        }

                    }
                },200);//延迟计算学术讲座视频
            }
        });
    }
    handleMove =(e,name)=>{
        let Distance = 480;///一次移动的距离
        let MovingDistance = this.state.MovingDistance;//已经移动的距离
        if(name === 'right'){
          let width=this.state.width;///所有子集总共的宽度
          let parentWidth=this.state.parentWidth;//父级宽度
          let surplusWidth=width - parentWidth;//剩余可移动距离
          if(Math.abs(MovingDistance - Distance)<  surplusWidth){//再次移动的距离小于剩余可移动宽度
              this.setState({
                  MovingDistance:MovingDistance - Distance,
                  leftClassName:'iconfont iconarrow-right',
                  rightClassName:'iconfont iconarrow-right',
                  scrollXClassName:'before after'
              })
          }else {
              this.setState({
                  MovingDistance: -surplusWidth,
                  leftClassName:'iconfont iconarrow-right ',
                  rightClassName:'iconfont iconarrow-right disabled',
                  scrollXClassName:'before'
              })
            }
          }
       if(name==='left'){
           if(MovingDistance + Distance < 0){///还有可移动空间
               this.setState({
                   MovingDistance:MovingDistance + Distance,
                   leftClassName:'iconfont iconarrow-right',
                   rightClassName:'iconfont iconarrow-right',
                   scrollXClassName:'before after'
               })
           }else {
               this.setState({
                   MovingDistance: 0,
                   leftClassName:'iconfont iconarrow-right disabled',
                   rightClassName:'iconfont iconarrow-right ',
                   scrollXClassName:'after'
               })
           }
       }

    };
    toMore=()=>{// 查看更多内容，跳转到更多的页面
        let channel=this.state.channel__id;///获取channel id
        if(channel){//存在channel id ，可以跳转查看更多
            window.location.hash='#/news?key='+channel+'&st=1';
        }else {
            message.warning('继续教育没有更多内容！')
        }
    };
    toShowNews=(hash,is_buy,integral_price,id,title,channel)=>{
        if(window.localStorage.getItem('userInfo')){
            if(is_buy){
                console.log(channel)
                let key = getIdFromUrl(channel)
               this.props.openModel(id,integral_price,title,key);
            }else {
                window.location.hash=hash;
            }
        }else {
            message.error('继续教育需要登录才能查看')
        }
    };
    render() {
        let {width,MovingDistance,leftClassName,rightClassName,scrollXClassName,news,channel__id,isSkeleton}=this.state;
        let {Mobile}=this.props;
        return <div style={{width:"100%",paddingBottom:'50px'}} className='video'>
            <p><span>继续教育</span></p>
            <p><span onClick={()=>this.toMore()}>More></span></p>
             <div className='videos'>
                 {!Mobile?<div id='video_list'>
                     <div className='left'>
                         <span className={leftClassName} onClick={(e)=>this.handleMove(e,'left')} />
                     </div>
                     <div className='right'>
                         <span className={rightClassName} onClick={(e)=>this.handleMove(e,'right')} />
                     </div>
                     <div id='scrollX' className={scrollXClassName}>
                         <div style={{width:width,transform:'translateX('+MovingDistance+'px)'}} className='clear'>
                             <Skeleton active loading={isSkeleton}>
                                 {news.map((item,index)=>{
                                     let hash='#/news/newshow?id='+item.id+"&key="+channel__id+'&st=1';
                                     return  <div className='item' key={index} onClick={()=>this.toShowNews(hash,item.integral_price&&item.is_buy&&item.transaction_status!==1,item.integral_price,item.id,item.title,item.channel)}>
                                         {item.big_image?
                                             <div className='video_img' style={{backgroundImage:'url('+item.big_image.file+')'}} />:
                                             <div className='video_img' ><span style={{color:'#666',position:'relative',top:'15px',left:'20px'}}>暂无封面</span></div>
                                         }
                                         <p><b>{item.title}</b></p>
                                         <div  className='span'>
                                             简介：{item.brief_introduction}
                                         </div>
                                            {item.integral_price&&item.is_buy&&item.transaction_status!==1&&
                                                <div style={{color:'#999',position:"absolute",bottom:'5px',left:'10px'}}>
                                                    此文章需要{item.integral_price}积分
                                                </div>
                                            }
                                     </div>
                                 })}
                             </Skeleton>
                         </div>
                     </div>
                     {news.length===0&&!isSkeleton?<Empty/>:''}
                 </div>:<div id='video_list' style={{height:'auto',width:'100%'}}>
                     <div id='scrollX' className='clear mobileScroll'>
                         <Skeleton active loading={isSkeleton}>
                             {news.map((item,index)=>{
                                 let hash='#/news/newshow?id='+item.id+"&key="+channel__id+'&st=1';
                                 return  <div className='item' key={index} onClick={()=>this.toShowNews(hash,item.integral_price&&item.is_buy&&item.transaction_status!==1,item.integral_price,item.id,item.title,item.channel)}>
                                     {item.big_image?
                                         <div className='video_img' style={{backgroundImage:'url('+item.big_image.file+')'}} />:
                                         <div className='video_img' ><span style={{color:'#666',position:'relative',top:'15px',left:'20px'}}>暂无封面</span></div>
                                     }
                                     <p><b>{item.title}</b></p>
                                     <div  className='span'>
                                         简介：{item.brief_introduction}
                                     </div>
                                     {item.integral_price&&item.is_buy&&item.transaction_status!==1&&
                                     <div  style={{color:'#999'}}>
                                         此文章需要{item.integral_price}积分
                                     </div>
                                     }
                                 </div>
                             })
                             }
                         </Skeleton>
                     </div>
                     {news.length===0&&!isSkeleton?<Empty/>:''}
                 </div>}

             </div>
         </div>
    }
}
export default Video